export const getStartedTitle = {
  fontSize: "2.625rem",
  fontWeight: 700,
  lineHeight: "2.125rem",
};

export const getStartedInfo = {
  lineHeight: "1.625rem",
  margin: "1.813rem 0 2.563rem",
  opacity: ".7",
};

export const joinButton = {
  padding: ".844rem 2.156rem",
  borderRadius: ".625rem",
  background: "#000",
  color: "#fff",
  ":hover": {
    background: "#000",
    transition: ".3s",
  },
  marginRight: "1.375rem",
  textTransform: "none",
};

export const learnMoreButton = {
  padding: ".844rem 2.156rem",
  borderRadius: ".625rem",
  background: "#fff",
  color: "#000",
  border: ".063rem solid #A1A1AA",
  textTransform: "none",
};
